import {contarPropiedadSumaWheres} from "../../Servicios/BD/Contadores/contarPropiedadSumaWheres";
import {where} from "firebase/firestore";

export const obtenerSaldo = async ({idUsuario}) => {

    let w = [where('idUsuario', '==', idUsuario), where('estado', '==', 'Aceptado'), where('tipo', '==', 'Deposito')];

    let depositos = await contarPropiedadSumaWheres({coleccion: 'depositos', propiedad: 'valor', wheres: w})

    let wRet = [where('idUsuario', '==', idUsuario), where('tipo', '==', 'Inversion')];

    let inversion = await contarPropiedadSumaWheres({coleccion: 'depositos', propiedad: 'valor', wheres: wRet})



    return depositos - inversion

}